import React, { useState, useEffect, useCallback } from "react";
import { PodcastBrand } from "../../../components";
import { IoChevronBackOutline, IoChevronForwardOutline } from "react-icons/io5";
import { isBrowser } from "react-device-detect";
import { scrollTop } from "../../../helpers/behavior";

export default function PodcastItem({ item, currentRadioId }) {
	const currentRadioPodcasts = item.find((radio) => radio.rpId === currentRadioId);
	const itemPerPage = 9;
	const margeToSupp = 2;
	const marginBrand = 14;
	const [currentIndex, setCurrentIndex] = useState(0);
	const isClient = typeof window === "object";
	const [pxToGo, setPxToGo] = useState(0);
	const getSize = useCallback(() => {
		return isClient ? window.innerWidth : undefined;
	}, [isClient]);
	const [windowSize, setWindowSize] = useState(getSize);
	const [itemSize, setItemSize] = useState(windowSize / itemPerPage - margeToSupp);
	const [overflowOption, setOverflowOption] = useState("");

	const isModulo = () => {
		if (currentRadioPodcasts.series.length % itemPerPage === 0) {
			return currentIndex > currentRadioPodcasts.series.length % itemPerPage && isBrowser;
		} else {
			return currentIndex >= currentRadioPodcasts.series.length % itemPerPage && isBrowser;
		}
	};
	useEffect(() => {
		scrollTop();
	}, []);

	useEffect(() => {
		if (isBrowser) {
			setOverflowOption("hidden");
		} else {
			setOverflowOption("visible");
		}
	}, []);

	useEffect(() => {
		if (!isClient) {
			return false;
		}
		function handleResize() {
			setWindowSize(getSize());
		}
		window.addEventListener("resize", handleResize);
		setItemSize(windowSize / itemPerPage - margeToSupp);
		setPxToGo(itemSize);
		return () => window.removeEventListener("resize", handleResize);
	}, [windowSize, itemSize, getSize, isClient]);

	const prev = () => {
		if (
			currentIndex <= currentRadioPodcasts.series.length - itemPerPage &&
			currentIndex > currentRadioPodcasts.series.length % itemPerPage
		) {
			setCurrentIndex((prevState) => prevState - itemPerPage);
			setPxToGo(itemSize);
		} else if (currentIndex <= (currentRadioPodcasts.series.length % itemPerPage) + itemPerPage) {
			setCurrentIndex((prevState) => prevState - (currentRadioPodcasts.series.length % itemPerPage));
			setPxToGo(itemSize);
		}
	};

	const next = () => {
		if (currentIndex === 0 || currentRadioPodcasts.series.length - currentIndex - itemPerPage > itemPerPage) {
			setCurrentIndex((prevState) => prevState + itemPerPage);
			setPxToGo(itemSize);
		} else if (currentRadioPodcasts.series.length - currentIndex - itemPerPage <= itemPerPage) {
			setCurrentIndex((prevState) => prevState + currentRadioPodcasts.series.length - currentIndex - itemPerPage);
			setPxToGo(itemSize);
		}
	};

	return (
		<div>
			{isModulo() && isBrowser && (
				<button
					onClick={prev}
					className="left-arrow-podcast-by-radio"
					style={{ height: windowSize / itemPerPage - marginBrand }}
				>
					<IoChevronBackOutline
						size={50}
						color={"white"}
						onMouseOver={({ target }) => (target.style.color = "rgba(227, 227, 227, 0.8)")}
						onClick={({ target }) => (target.style.color = "rgba(227, 227, 227, 0.8)")}
						onMouseOut={({ target }) => (target.style.color = "white")}
					/>
				</button>
			)}
			{currentRadioPodcasts ? (
				<div className="carousel-content-wrapper" style={{ overflowX: overflowOption }}>
					<div
						className="carousel-content-podcast-by-radio"
						style={{ transform: `translateX(-${currentIndex * pxToGo}px` }}
					>
						{currentRadioPodcasts.series.map((item) => (
							<PodcastBrand item={item} windowSize={windowSize} key={item.idseries?.toString()} />
						))}
					</div>
				</div>
			) : null}
			{currentIndex < currentRadioPodcasts.series.length - itemPerPage && isBrowser && (
				<button
					onClick={next}
					className="right-arrow-podcast-by-radio"
					style={{ height: windowSize / itemPerPage - marginBrand }}
				>
					<IoChevronForwardOutline
						size={50}
						color={"white"}
						onMouseOver={({ target }) => (target.style.color = "rgba(227, 227, 227, 0.8)")}
						onClick={({ target }) => (target.style.color = "rgba(227, 227, 227, 0.8)")}
						onMouseOut={({ target }) => (target.style.color = "white")}
					/>
				</button>
			)}
		</div>
	);
}
